import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { AxiosResponse } from "axios";

export default {
    async list(param: types.ReqInquiryList): Promise<types.ResInquiryList> {
        const res = {} as types.ResInquiryList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/inquiry/list", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async detail(idx: number): Promise<types.ResInquiry> {
        const res = {} as types.ResInquiry;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/inquiry/detail/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async addForComment(idx: number, param: types.ReqComment): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/inquiry/comment/add/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async modifyForComment(idx: number, param: types.ReqComment): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/inquiry/comment/modify/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async remove(param: types.ReqIdxList): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/inquiry/remove", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async exportExcel(param: types.ReqInquiryForExcel): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post("/inquiry/export/excel", param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },
};
